import React, { useState, useEffect } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import headerImage from "../../../../../assets/img/longarrow.jpg";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import { formatDate } from "utils/dateFormatter";

const EditPolicyDrawer = ({ isOpen, onClose, policy, onUpdatePolicy }) => {
  const [formData, setFormData] = useState(policy);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    // Update formData whenever the policy prop changes
    setFormData(policy);
  }, [policy]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleToggleEdit = () => {
    if (isEditing) {
      // Save changes when in editing mode
      onUpdatePolicy(formData);
      setIsEditing(false);
    } else {
      // Enable editing mode
      setIsEditing(true);
    }
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>{isEditing ? "Edit Policy" : "View Policy"}</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Title"
            name="title"
            value={formData?.title || ""}
            onChange={handleInputChange}
            placeholder="Enter the policy title"
            type="text"
            isReadOnly={!isEditing}
          />
          <ReusableInput
            label="Content"
            name="content"
            value={formData?.content || ""}
            onChange={handleInputChange}
            placeholder="Enter the policy content"
            type="richtext"
            isReadOnly={!isEditing} 
          />
          <ReusableInput
            label="Date Added"
            name="dateAdded"
            value={formatDate(formData?.created_at) || ""}
            isReadOnly  // Keep date read-only
            placeholder="Auto-generated"
          />
          <ReusableInput
            label="Last Updated"
            name="updated_at"
            value={formatDate(formData?.updated_at) || ""}
            isReadOnly  // Keep date read-only
            placeholder="Auto-generated"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize="15px" width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleToggleEdit} fontSize="15px" width="100px" height="40px">
            {isEditing ? "Save" : "Edit"}
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditPolicyDrawer;
